export default class DataSourceBase {
  constructor(Vue, id, data) {
    this._id = id
    this.$store = Vue.$store
    this.$router = Vue.$router
    this.$route = Vue.$route
    this.$authCore = Vue.$authCore
    this.Vue = Vue

    if (!this.$store) {
      return
    }
    // если модуль зарегистрирован - выходим
    if (this.$store.state[this.getStoreModuleName()] !== undefined) {
      return
    }
    // формирование модуля vuex
    var storeModule = {
      namespaced: true,
      state: {
        data: data
      },
      mutations: {
        setData(state, data) {
          state.data = data
        }
      }
    }
    // регистрация модуля
    this.$store.registerModule(this.getStoreModuleName(), storeModule)
  }

  getData() {
    return this.$store.state[this.getStoreModuleName()].data
  }

  /** Формирование имени для vuex модуля  */
  getStoreModuleName() {
    return `datasource_${this._id}`
  }
}